import { createRouter, createWebHashHistory } from 'vue-router';
import Home from './views/Home.vue';

export default createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/:storeName/:publisher?',
      name: 'home',
      component: Home,
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/itunes',
    },
  ],
});
